import React from 'react';

import { Row, Col } from 'antd';
import Input from 'components/Common/Form/Input/Input';
import { Container } from './styles';

interface IProps {
	exigenciasProcesso: string[];
	exigenciasVara: string[];
}
interface IData {
	data: IProps;
}

const ProcessoVara: React.FC<IData> = ({ data }) => {
	return (
		<Container>
			<Row gutter={15}>
				<Col span={6}>
					<h5>Processo</h5>
				</Col>
				<Col span={18}>
					<h5>Vara Criminal</h5>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={6}>
					<Input
						name="exigProcesso01"
						value={
							(data?.exigenciasProcesso && data.exigenciasProcesso[0]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={18}>
					<Input
						name="exigVara01"
						value={(data?.exigenciasVara && data?.exigenciasVara[0]) || ''}
						disabled
					/>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={6}>
					<Input
						name="exigProcesso02"
						value={
							(data?.exigenciasProcesso && data.exigenciasProcesso[1]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={18}>
					<Input
						name="exigVara02"
						value={(data?.exigenciasVara && data.exigenciasVara[1]) || ''}
						disabled
					/>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={6}>
					<Input
						name="exigProcesso03"
						value={
							(data?.exigenciasProcesso && data.exigenciasProcesso[2]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={18}>
					<Input
						name="exigVara03"
						value={(data?.exigenciasVara && data.exigenciasVara[2]) || ''}
						disabled
					/>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={6}>
					<Input
						name="exigProcesso04"
						value={
							(data?.exigenciasProcesso && data.exigenciasProcesso[3]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={18}>
					<Input
						name="exigVara04"
						value={(data?.exigenciasVara && data.exigenciasVara[3]) || ''}
						disabled
					/>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={6}>
					<Input
						name="exigProcesso05"
						value={
							(data?.exigenciasProcesso && data.exigenciasProcesso[4]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={18}>
					<Input
						name="exigVara05"
						value={(data?.exigenciasVara && data.exigenciasVara[4]) || ''}
						disabled
					/>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={6}>
					<Input
						name="exigProcesso06"
						value={
							(data?.exigenciasProcesso && data.exigenciasProcesso[5]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={18}>
					<Input
						name="exigVara06"
						value={(data?.exigenciasVara && data.exigenciasVara[5]) || ''}
						disabled
					/>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={6}>
					<Input
						name="exigProcesso07"
						value={
							(data?.exigenciasProcesso && data.exigenciasProcesso[6]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={18}>
					<Input
						name="exigVara07"
						value={(data?.exigenciasVara && data.exigenciasVara[6]) || ''}
						disabled
					/>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={6}>
					<Input
						name="exigProcesso08"
						value={
							(data?.exigenciasProcesso && data.exigenciasProcesso[7]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={18}>
					<Input
						name="exigVara08"
						value={(data?.exigenciasVara && data.exigenciasVara[7]) || ''}
						disabled
					/>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={6}>
					<Input
						name="exigProcesso09"
						value={
							(data?.exigenciasProcesso && data.exigenciasProcesso[8]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={18}>
					<Input
						name="exigVara09"
						value={(data?.exigenciasVara && data.exigenciasVara[8]) || ''}
						disabled
					/>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={6}>
					<Input
						name="exigProcesso10"
						value={
							(data?.exigenciasProcesso && data.exigenciasProcesso[9]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={18}>
					<Input
						name="exigVara10"
						value={(data?.exigenciasVara && data.exigenciasVara[9]) || ''}
						disabled
					/>
				</Col>
			</Row>
		</Container>
	);
};

export default ProcessoVara;
